<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceProjectId'
        label= '产品ID'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '180'>
      </el-table-column>
      <el-table-column
        prop= 'version'
        label= '版本'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '320'>
        <template slot-scope='scope'>
          <el-link :href="apiUrl + '/deviceModel/confJson?id='+scope.row.id">导出配置</el-link>
          <el-button @click='manageModelSence(scope.row)' type='text' size='small' style="color: #209323">执行模式管理</el-button>
          <el-button @click='manageDeviceProperty(scope.row)' type='text' size='small' style="color: #209323">属性管理</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="产品ID" :label-width="formLabelWidth" prop="deviceProjectId">
          <el-input v-model="form.deviceProjectId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="版本" :label-width="formLabelWidth" prop="version">
          <el-input v-model="form.version" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="单独控制页面关键字" :label-width="formLabelWidth" prop="controlPageKey">
          <el-input v-model="form.controlPageKey" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否是ai" :label-width="formLabelWidth" prop="isAi">
          <el-radio-group v-model="form.isAi" size="medium">
            <el-radio-button label=1>是</el-radio-button>
            <el-radio-button label=0>否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设备接口类型" :label-width="formLabelWidth" prop="interfaceType">
          <el-radio-group v-model="form.interfaceType" size="medium">
            <el-radio-button label=1>己方平台</el-radio-button>
            <el-radio-button label=20>普锐平台</el-radio-button>
            <el-radio-button label=100>绿野数据(气象站)</el-radio-button>
            <el-radio-button label=101>绿野数据(温湿度光照)</el-radio-button>
            <el-radio-button label=102>绿野数据(土壤墒情)</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模型大类" :label-width="formLabelWidth" prop="type">
          <el-radio-group v-model="form.type" size="medium">
            <el-radio-button label=1>公司主控</el-radio-button>
            <el-radio-button label=2>公司DTU</el-radio-button>
            <el-radio-button label=3>第三方平台</el-radio-button>
            <el-radio-button label=5>语音喇叭</el-radio-button>
            <el-radio-button label=10>虫情设备</el-radio-button>
          </el-radio-group>
        </el-form-item>        
        <el-form-item label="使用说明" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off" type="textarea" :rows="8"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="curRow.name + '  属性管理'" :visible.sync="dialogDevicePropertyVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <DeviceModelProperty :deviceModelId="curRow.id"></DeviceModelProperty>
    </el-dialog>

    <el-dialog :title="curRow.name + '  执行模型管理'" :visible.sync="dialogDeviceControlSenceActionModelVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <DeviceControlSenceActionModel :deviceModelId="curRow.id"></DeviceControlSenceActionModel>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import DeviceModelProperty from '../deviceModelProperty/Index.vue'
import DeviceControlSenceActionModel from '../deviceControlSenceActionModel/Index.vue'

export default {
  components: {
    DeviceModelProperty,
    DeviceControlSenceActionModel
  },
  props: {
    deviceProjectId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data () {
    return {
      tableData: [],
      apiUrl: '',
      name: '',
      dialogFormVisible: false,
      dialogDeviceControlSenceActionModelVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        version: null,
        descr: null,
        deviceProjectId: null,
        commandType: null,
        interfaceType: null,
        isAi: null,
        type: null,
        controlPageKey: null
      },
      rules: {
        name: [{ required: true, message: '名称 不能为空', trigger: ['change', 'blur'] }, { message: '名称 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        version: [{ required: true, message: '版本 不能为空', trigger: ['change', 'blur'] }, { message: '版本 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        deviceProjectId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '产品ID 不能为空', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      dialogDevicePropertyVisible: false,
      curRow: {}
    }
  },
  created () {
    this.apiUrl = this.$global.apiUrl
    this.query()
  },
  watch: {
    deviceProjectId: {
      handler (newV, oldV) {
        this.form.deviceProjectId = this.deviceProjectId
        this.query()
      },
      immediate: true
    }
  },
  methods: {
    manageModelSence (row) {
      this.curRow = {...row}
      this.dialogDeviceControlSenceActionModelVisible = true
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceModel/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/deviceModel/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceProjectId=${that.deviceProjectId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    manageDeviceProperty (row = {}) {
      this.curRow = {...row}
      this.dialogDevicePropertyVisible = true
    },
    digAdd () {
      this.form = {deviceProjectId: this.deviceProjectId}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceModel/add'
          if (that.form.id) {
            url = '/deviceModel/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/deviceModel/Index.vue